import markConversationsReadInListViewStore from '../actions/triage/markConversationsReadInListViewStore';
import markItemsReadInListViewStore from '../actions/triage/markItemsReadInListViewStore';
import { actionNames } from 'owa-mail-store-actions';
import { subscribe } from 'satcheljs/lib/legacy/stitch';
import { getRowIdsFromRowKeys } from 'owa-mail-list-store';
export default function markAllAsReadStitch() {
    subscribe(actionNames.MarkAllAsReadStoreUpdate, function (tableView, markAsRead) {
        // Table may not exist if user is clicking on context menu option for an unselected folder
        if (!tableView) {
            return;
        }
        switch (tableView.tableQuery.listViewType) {
            case 0 /* Conversation */:
                markConversationsReadInListViewStore(tableView.rowKeys, markAsRead, tableView, false /* updateFolderCounts */);
                break;
            case 1 /* Message */:
                var itemIdStrings = getRowIdsFromRowKeys(tableView.rowKeys, tableView.id);
                markItemsReadInListViewStore(itemIdStrings, markAsRead);
                break;
        }
    });
}
//# sourceMappingURL=markAllAsReadStitch.js.map